import React, { useEffect, useState } from "react";

import { Formik, Form } from "formik";
import { RightMinimalArrow } from "icons";

import usersApi from "apis/users";
import {
  Button,
  PageLoader,
  Pane,
  Steps,
  Typography,
} from "clearsense-ui/components";
import { Input, Select, Textarea } from "clearsense-ui/components/formik";

import {
  CONVERSION_TYPE,
  FHIR_CONVERSION_VALIDATION,
  INITIAL_FHIR_CONVERSION_VALUES,
} from "../../constants";

const Converter = ({ setSelectedConverter, handleCancel, setFHIRDetails }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [stewards, setStewards] = useState([]);
  const [submitted, setSubmitted] = useState(false);

  const fetchStewards = async () => {
    try {
      setIsLoading(true);
      const { data } = await usersApi.fetch(1, 1000, "");
      setStewards(
        data?.users?.map(user => ({ label: user.name, value: user.key }))
      );
    } catch (error) {
      logger.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const saveDetails = values => {
    const fhirDetails = {
      conversion_type: values.conversionType.value,
      name: values.conversionName,
      description: values.description,
      drafter_id: values.drafter.value,
      approver_id: values.approver.value,
    };
    setFHIRDetails(fhirDetails);
    setSelectedConverter(values.conversionType);
  };

  useEffect(() => fetchStewards(), []);

  return (
    <Formik
      initialValues={INITIAL_FHIR_CONVERSION_VALUES}
      validationSchema={FHIR_CONVERSION_VALIDATION}
      onSubmit={saveDetails}
      validateOnBlur={submitted}
      validateOnChange={submitted}
      enableReinitialize
    >
      {({ isSubmitting }) => (
        <Form>
          <Pane.Body className="py-2 space-y-2 overflow-visible">
            <>
              <Typography style="h5">
                Select a converter and convert non-compliant data to FHIR.
              </Typography>
              <Steps
                steps={[
                  <Typography key="categories">Select converter</Typography>,
                  <Typography key="database_type">
                    Enter Data for Conversion
                  </Typography>,
                ]}
                currentStep={1}
              />
              {isLoading ? (
                <PageLoader />
              ) : (
                <div className="flex-col space-y-4 w-full">
                  <Input
                    name="conversionName"
                    label="Conversion Name"
                    placeholder="Enter a name for the conversion"
                    required
                  />
                  <Textarea
                    name="description"
                    label="Description"
                    placeholder="Enter Description"
                    required
                  />
                  <Select
                    label="Conversion Type"
                    placeholder="Select conversion type"
                    name="conversionType"
                    size="small"
                    options={CONVERSION_TYPE}
                    strategy="fixed"
                    required
                  />
                  <Select
                    label="Drafter"
                    size="small"
                    placeholder="Select Steward"
                    name="drafter"
                    options={stewards}
                    required
                  />
                  <Select
                    label="Approver"
                    size="small"
                    placeholder="Select Steward"
                    name="approver"
                    options={stewards}
                    required
                  />
                </div>
              )}
            </>
          </Pane.Body>
          <Pane.Footer>
            <div className="flex flex-row-reverse items-center w-full">
              <Button
                label="Next Step"
                icon={RightMinimalArrow}
                iconPosition="right"
                loading={isSubmitting}
                disabled={isSubmitting}
                size="large"
                type="submit"
                onClick={() => setSubmitted(true)}
              />
              <Button
                label="Cancel"
                style="text"
                size="large"
                onClick={handleCancel}
              />
            </div>
          </Pane.Footer>
        </Form>
      )}
    </Formik>
  );
};

export default Converter;
